<script>
import { ref, computed } from 'vue'
import ShootingGalleryItem from '@/components/shooting/ShootingGalleryItem.vue'
import ShootingGalleryItemFullscreen from '@/components/shooting/ShootingGalleryItemFullscreen.vue'

export default {
  name: 'ShootingGalleryByOrder',
  components: {
    ShootingGalleryItem,
    ShootingGalleryItemFullscreen
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const show = ref(null)

    // Computed property to order images by order and select the most processed version
    const orderImage = computed(() => {
      if (props.images.length === 0) return []

      const maxOrder = Math.max(...props.images.map((img) => img.order))
      const priorityTypes = [...props.types].reverse()

      const getHighestPriorityImage = (imagesInOrder) => {
        return priorityTypes.reduce((selected, type) => {
          return selected || imagesInOrder.find((img) => img.imageType === type)
        }, undefined)
      }

      const orderedImages = Array.from({ length: maxOrder + 1 }, (_, orderIndex) => {
        const imagesInOrder = props.images.filter((img) => img.order === orderIndex)
        return getHighestPriorityImage(imagesInOrder)
      })

      return orderedImages.filter(Boolean)
    })

    const toggleFullscreen = (isModalOpen, imageIndex) => {
      show.value = isModalOpen ? imageIndex : null
    }

    return {
      show,
      orderImage,
      toggleFullscreen
    }
  }
}
</script>

<template>
  <div v-if="images.length !== 0">
    <div class="img-row d-flex justify-center">
      <div class="img-row-block" v-for="(image, index) in orderImage" :key="index">
        <ShootingGalleryItem :image="image" :url="image.url" :index="index" @toggle-fullscreen="toggleFullscreen" />
      </div>
    </div>

    <!-- Fullscreen component outside the loop -->
    <ShootingGalleryItemFullscreen
      v-if="show !== null"
      :images="orderImage"
      :current-index="show"
      @toggle-fullscreen="toggleFullscreen"
    />
  </div>
</template>

<style lang="sass" scoped>
.img-row
  display: flex
  flex-wrap: wrap
  margin-bottom: 20px
</style>
